import { Option, Schema } from 'effect'

export const sleep = async (sec: number): Promise<unknown> =>
  // eslint-disable-next-line promise/avoid-new -- setTimeout はコールバック API しか無いため Promise で包む
  await new Promise((resolve) => {
    setTimeout(resolve, sec * 1000)
  })

const decodeJson = Schema.decodeUnknownOption(Schema.fromJsonString(Schema.Unknown))

// 失敗は undefined で表す (JSON は undefined を表現できないので成功と区別できる)。
// effect の Option で返さないのは、利用側のパッケージが自分の effect で扱うと、両パッケージの effect の major を同時に上げる必要が生じるため。
export const parseJsonIfValid = (x: string): unknown => Option.getOrUndefined(decodeJson(x))
